import { FC } from "react";

import { ChevronIcon } from "../icons";

import {
  getMonthMatrix,
  isSameDay,
  isWithinRange,
  startOfDay,
} from "./calendarMatrix";
import styles from "./Calendar.module.css";

const WEEKDAYS = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

interface CalendarProps {
  viewDate: Date;
  // Для выбора одной даты rangeEnd не передаётся.
  rangeStart: Date | null;
  rangeEnd?: Date | null;
  // Дни раньше minDate недоступны.
  minDate?: Date | null;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onSelectDay: (day: Date) => void;
}

export const Calendar: FC<CalendarProps> = ({
  viewDate,
  rangeStart,
  rangeEnd = null,
  minDate = null,
  onPrevMonth,
  onNextMonth,
  onSelectDay,
}) => {
  const minDay = minDate ? startOfDay(minDate) : null;

  return (
    <div className={styles.calendar}>
      <div className={styles.calendarHeader}>
        <button type="button" className={styles.navBtn} onClick={onPrevMonth}>
          <ChevronIcon direction="left" fill="#ffffff" />
        </button>
        <span>
          {viewDate.toLocaleString("en-US", { month: "long", year: "numeric" })}
        </span>
        <button type="button" className={styles.navBtn} onClick={onNextMonth}>
          <ChevronIcon direction="right" fill="#ffffff" />
        </button>
      </div>

      <div className={styles.weekdays}>
        {WEEKDAYS.map((day) => (
          <span key={day}>{day}</span>
        ))}
      </div>

      <div className={styles.days}>
        {getMonthMatrix(viewDate).map((week) =>
          week.map(({ date, inCurrentMonth }) => {
            const isUnavailable =
              !inCurrentMonth || (!!minDay && date < minDay);
            const isSelected =
              (!!rangeStart && isSameDay(date, rangeStart)) ||
              (!!rangeEnd && isSameDay(date, rangeEnd));
            const isInRange =
              !!rangeStart &&
              !!rangeEnd &&
              isWithinRange(date, rangeStart, rangeEnd);

            return (
              <button
                type="button"
                key={date.toISOString()}
                disabled={isUnavailable}
                className={[
                  styles.day,
                  isUnavailable && styles.dayMuted,
                  isInRange && styles.dayInRange,
                  isSelected && styles.daySelected,
                ]
                  .filter(Boolean)
                  .join(" ")}
                onClick={() => onSelectDay(date)}
              >
                {date.getDate()}
              </button>
            );
          }),
        )}
      </div>
    </div>
  );
};
